import React, { useEffect, useState } from 'react'

import Placeholder from '../Placeholder'
import Typography from '../Typography'
import * as Styled from './Brandy.styles'

const Brandy = ({
  symbol,
  text,
  variant,
  modal,
  content,
  disclaimer,
  ...props
}) => {
  const finalText = disclaimer?.text || disclaimer || text
  if (!modal && !content && !finalText) {
    return (
      <Placeholder type="warning">
        <Typography variant="small">Missing Disclaimer Or Modal</Typography>
        <Typography>
          The disclaimer or modal can&apos;t be rendered here. It is most likely
          a combination of incorrect brand token & brandy reference inside
          Contentful
          <i>sites/src/gatsby-config</i>.
        </Typography>
      </Placeholder>
    )
  }

  const renderText = () => {
    if (!finalText) return null
    if (Array.isArray(finalText)) return finalText // Directly return an array of React elements
    if (React.isValidElement(finalText)) return finalText // Render as-is if it's a React element

    // Otherwise, assume it's a string and render as HTML
    // eslint-disable-next-line react/no-danger
    return <span dangerouslySetInnerHTML={{ __html: finalText }} />
  }

  const renderSymbol = () => {
    if (!symbol) return null

    return (
      <span
        // Has to be done because of the possible html tags from brandy
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `${symbol ? `<sup>${symbol}</sup>` : ''}`.trim(),
        }}
      />
    )
  }

  return (
    <Styled.Brandy
      {...props}
      className="leshen-brandy"
      variant={variant || 'legal'}
    >
      {renderText()}
      {renderSymbol()}
      {!finalText && content}
      {modal && modal}
    </Styled.Brandy>
  )
}

const BrandyWrapper = (props) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [setMounted])

  return mounted && <Brandy {...props} />
}

export default BrandyWrapper
